import React from "react";
// Import Link
import { Link } from "react-router-dom";
import tag from "../../assets/img/icon/tag.png";
import map from "../../assets/img/icon/map.png";
import cal from "../../assets/img/icon/cal.png";
// Import Img
import Organize from "../../assets/img/sidebar/project_organizer.png";
import img1 from "../../assets/img/sidebar/rec-cas-1.png";
import img2 from "../../assets/img/sidebar/rec-cas-2.png";
import img3 from "../../assets/img/sidebar/rec-cas-3.png";
import img4 from "../../assets/img/sidebar/rec-cas-4.png";

const Sidebar = () => {
  const ReceData = [
    {
      img: img1,
      title: `Badminton club — new term times`,
      date: "Updated weekly",
    },
    {
      img: img2,
      title: `Integration evening — schools`,
      date: "See events page",
    },
    {
      img: img3,
      title: `Seasonal swim / football / cricket blocks`,
      date: "Newsletter",
    },
    {
      img: img4,
      title: `Independence Day celebration`,
      date: "Save the date — news soon",
    },
  ];
  return (
    <>
      <div className="col-lg-4">
        <div className="sidebar_first">
          <div className="project_organizer_wrapper sidebar_boxed">
            <div className="project_organizer_img">
              <img src={Organize} alt="img" />
            </div>
            <div className="project_organizer_text">
              <h5>Organised by:</h5>
              <h3>PCF board</h3>
              <p>Pakistani Cultural &amp; Sports Organisation</p>
              <ul>
                <li>
                  <img src={tag} alt="icon" /> Category:
                  <span>Community support</span>
                </li>
                <li>
                  <img src={map} alt="icon" /> Location:
                  <span>Sweden</span>
                </li>
                <li>
                  <img src={cal} alt="icon" /> Status:
                  <span>Ongoing programmes</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="recent_causes_wrapper sidebar_boxed">
            <div className="sidebar_heading_main">
              <h3>Related updates</h3>
            </div>
            {ReceData.map((data, index) => (
              <div className="recent_donet_item" key={index}>
                <div className="recent_donet_img">
                  <Link to="/news">
                    <img src={data.img} alt="img" />
                  </Link>
                </div>
                <div className="recent_donet_text">
                  <div className="sidebar_inner_heading">
                    <h4>
                      <Link to="/news">{data.title}</Link>
                    </h4>
                  </div>
                  <p>{data.date}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
